import { FileBrowserGdt } from "components/FlyoutFiles/FlyoutFilesGDT";
import { useProjectDataContext } from "pages/project/ProjectDataProvider";

export const ProjectTabFiles = () => {
  const { project } = useProjectDataContext();
  // wraps in a div with height set so the file browser doesn't collapse
  // down to minimum height - especially important when no files in project
  return (
    <div style={{ height: "100%", minHeight: "200px" }}>
      <FileBrowserGdt projectKey={project.key} />
    </div>
  );
};
